import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from './servicio-fechas-query.service'
import { promise } from 'protractor';


@Injectable({
  providedIn: 'root'
})
export class ServiDataUnidadNegocioServiceService {

  unidadDeNegocioSeleccionada=''
  cuencaseleccionada=''
  todalacuenca=false
  arrayActividadesPTW=[]

  constructor(public servicioFechasQueryService:ServicioFechasQueryService) { }

  dataChart1Default = [
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    }, 
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart1 = [
    {
      "name": "Pendiente de aprobación",
      "value": 0
    },
    {
      "name": "Aprobado",
      "value": 0
    }, 
    {
      "name": "Denegado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    },
    {
      "name": "Cerrado",
      "value": 0
    }
  ];

  dataChart4Default = [
    {
      "name": "W en Alturas",
      "value": 0
    },
    {
      "name": "W en Caliente",
      "value": 0
    }, 
    {
      "name": "Levantamiento mec.",
      "value": 0
    },
    {
      "name": "Energías peligrosas",
      "value": 0
    },
    {
      "name": "Confinados",
      "value": 0
    },
    {
      "name": "Hazmat",
      "value": 0
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0
    },
    // {
    //   "name": "OTROS",
    //   "value": 0
    // }
  ];

  dataChart4 = [
    {
      "name": "W en Alturas",
      "value": 0
    },
    {
      "name": "W en Caliente",
      "value": 0
    }, 
    {
      "name": "Levantamiento mec.",
      "value": 0
    },
    {
      "name": "Energías peligrosas",
      "value": 0
    },
    {
      "name": "Confinados",
      "value": 0
    },
    {
      "name": "Hazmat",
      "value": 0
    },
    {
      "name": "Sup. y monitoreo",
      "value": 0
    },
    // {
    //   "name": "OTROS",
    //   "value": 0
    // }
  ];

  dataChart2Default= [
    {
      "name": "Trabajadores",
      "value": 0,
      "extra": {
        "code": "de"
      }
    },
  ]

 dataChart2= [
    {
      "name": "Trabajadores",
      "value": 0,
      "extra": {
        "code": "de"
      }
    },
  ]

  dataChart3= [
    {
      "name": "PTW con aislamiento",
      "value": 0,
      "extra": {
        "code": "de"
      }
    },
  ]

  dataChart3Default= [
    {
      "name": "PTW con aislamiento",
      "value": 0,
      "extra": {
        "code": "de"
      }
    },
  ]

  queryChart1(callback){
    this.resetea(()=>{

    let  fechaquerymin = this.servicioFechasQueryService.fechaquerymin
    let  fechaquerymax = this.servicioFechasQueryService.fechaquerymax
    let  query:any  

      query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("unidadDeNegocio","==",this.unidadDeNegocioSeleccionada);
       
    
      query.get().then((docs)=>{
        docs.forEach((doc)=>{
          this.clasificaChart1(doc)
          this.clasificaChart2(doc)
          this.clasificaChart3(doc)
          this.clasificaChart4(doc)
        })
        // this.dataChart1=[...this.dataChart1]
      }).catch((err)=>{
        console.log(err);
      }).then(()=>{
        callback(this.dataChart1, this.dataChart2, this.dataChart3, this.dataChart4)
        // callback(this.dataChart1)
      })

    })//resetea
   }

   resetea(callback){
    this.dataChart1[0].value=0
    this.dataChart1[1].value=0
    this.dataChart1[2].value=0
    this.dataChart1[3].value=0
    this.dataChart1[4].value=0

    this.dataChart2[0].value=0

    this.dataChart3[0].value=0


    callback()
  }


  clasificaChart1(doc){
    if(doc.data().status == 'Pendiente de aprobación'){this.dataChart1[0].value ++}else
    if(doc.data().status == 'Aprobado' ){this.dataChart1[1].value ++}else
    if(doc.data().status == 'Denegado' ){this.dataChart1[2].value ++}else
    if(doc.data().status == 'cerrado'  ){this.dataChart1[3].value ++}else
    if(doc.data().status == 'Cerrado'  ){this.dataChart1[4].value ++}
  }




  
  clasificaChart2(doc){
    // doc.data().arrayDeEmpleados.array.forEach((element) => {

    // });
    this.dataChart2[0].value += doc.data().arrayDeEmpleados.length
  }


  clasificaChart3(doc){
    if(doc.data().requiereAutoridadAislante == true){
      this.dataChart3[0].value ++
    }
  }


  clasificaChart4(doc){


    this.arrayActividadesPTW=[]

      if(doc.data().arrayActividadesPTW == undefined){
        doc.data().arrayDeEmpleados.forEach((empleado) => {

          empleado.arraydeactividades.forEach(actividadTrabajador=>{

            //el some arroja true si hay un item en el array con el parámetro actividad igual 
            if(this.arrayActividadesPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == false){
               this.arrayActividadesPTW.push(actividadTrabajador.actividad)  
               this.catalogaPorTareasDataChart4(actividadTrabajador.actividad)       
            }
        
          })

        });
      }else
      if(doc.data().arrayActividadesPTW != undefined){
        doc.data().arrayActividadesPTW.forEach((element) => {
          
          //el some arroja true si hay un item en el array con el parámetro actividad igual 
          if(this.arrayActividadesPTW.some((item)=>item.actividad == element.actividad) == false){
            this.arrayActividadesPTW.push(element.actividad)  
            this.catalogaPorTareasDataChart4(element.actividad)       
          }
          
        });
      }
  }


  catalogaPorTareasDataChart4(tarea){
    if(tarea == "TRABAJO EN ALTURAS" ){this.dataChart4[0].value ++}else
    if(tarea == "TRABAJO EN CALIENTE" ){this.dataChart4[1].value ++}else
    if(tarea == "LEVANTAMIENTO MECÁNICO" ){this.dataChart4[2].value ++}else
    if(tarea == "ENERGÍAS PELIGROSAS"){this.dataChart4[3].value ++}else
    if(tarea == "ESPACIOS CONFINADOS"){this.dataChart4[4].value ++}else
    if(tarea == "HAZMAT"){this.dataChart4[5].value ++}else
    if(tarea == "SUPERVISIÓN Y MONITOREO"){this.dataChart4[6].value ++}
    //else if(tarea == "OTROS"){this.dataChart4[7].value ++}
  }




  // ESTO ME SIRVE
  //   si el arrayActividadesPTW es indefinido, o sea que es de un ptw viejo anterior a esta actualizacion, creamos ese array de actividades a partir de la data existente en los trabajadores
  //   if(respuesta.data().arrayActividadesPTW != undefined){
  //     this.arrayActividadesPTW = respuesta.data().arrayActividadesPTW
  //   }else
  //   if(respuesta.data().arrayActividadesPTW == undefined){
  //     respuesta.data().arrayDeEmpleados.forEach(element => {
  //       this.desglosaActividadesDeTrabajadores(element.arraydeactividades)
  //     });
  //   }

  desglosaActividadesDeTrabajadores(arrayActividadesTrabajador){
   return new Promise((resolve,reject)=>{

    arrayActividadesTrabajador.forEach(actividadTrabajador=>{
      //el some arroja true si hay un item en el array con el parámetro actividad igual 
      if(this.arrayActividadesPTW.some((item)=>item.actividad == actividadTrabajador.actividad) == false){
         this.arrayActividadesPTW.push({actividad:actividadTrabajador.actividad, herramientasYcontroles:null})        
      }
    })

   })
    
  }
  



}//fin de clase
